// extracted by mini-css-extract-plugin
export default {"melodyVideo":"DR-z","isFullWidth":"ER-z","landingPageVideo":"FR-z","play":"GR-z","iframeVideo":"HR-z","playHidden":"IR-z","fullwidth":"JR-z"};